/**
 * @generated SignedSource<<fdda3907d2591b05ec476be1c802c405>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type noPermissionViews_projectsDirectoryV3$data = {
  readonly jira: {
    readonly canCreateProject: boolean | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"noPermissions_projectsDirectoryV3">;
  readonly " $fragmentType": "noPermissionViews_projectsDirectoryV3";
};
export type noPermissionViews_projectsDirectoryV3$key = {
  readonly " $data"?: noPermissionViews_projectsDirectoryV3$data;
  readonly " $fragmentSpreads": FragmentRefs<"noPermissionViews_projectsDirectoryV3">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "cloudId"
    }
  ],
  "kind": "Fragment",
  "name": "noPermissionViews_projectsDirectoryV3",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "noPermissions_projectsDirectoryV3"
    },
    {
      "concreteType": "JiraQuery",
      "kind": "LinkedField",
      "name": "jira",
      "plural": false,
      "selections": [
        {
          "alias": "canCreateProject",
          "args": [
            {
              "kind": "Variable",
              "name": "cloudId",
              "variableName": "cloudId"
            },
            {
              "kind": "Literal",
              "name": "type",
              "value": "CREATE_PROJECT"
            }
          ],
          "kind": "ScalarField",
          "name": "canPerform"
        }
      ]
    }
  ],
  "type": "Query"
};

(node as any).hash = "788b343e3e8a65ae1b059245a8e7e41c";

export default node;
